// Constantes pour les statuts métiers et associations
// Ces constantes correspondent aux valeurs définies dans l'entité backend PersonneSousStatut.php

export const STATUTS_METIER_ASSO = {
    // Associations
    ASSOCIATION_MORALE_FFBT: 'association.morale.ffbt', // Fédération française de ball-trap (FFBT)
    ASSOCIATION_MORALE_FFS: 'association.morale.ffs', // Fédération française de ski (FFS)
    ASSOCIATION_MORALE_FFTIR: 'association.morale.fftir', // Fédération française de tir sportif (FFTIR)
    ASSOCIATION_MORALE_FNC: 'association.morale.fnc', // La Fédération nationale de chasse (FNC)
    ASSOCIATION_MORALE_AFFILIE_FFTIR: 'association.morale.affilie_fftir', // Club et association affilié à la Fédération Française de Tir (FFTIR)
    ASSOCIATION_MORALE_AFFILIE_FFS: 'association.morale.affilie_ffs', // Club et association affilié à la Fédération Française de Ski (FFS)
    ASSOCIATION_MORALE_AFFILIE_FFBT: 'association.morale.affilie_ffbt', // Club et association affilié à la Fédération Française de Ball-Trap (FFBT)
    ASSOCIATION_MORALE_AFFILIE_FNC: 'association.morale.affilie_fnc', // Club et association affilié à la Fédération nationale de chasse (FNC)
    ASSOCIATION_MORALE_NON_AFFILIE: 'association.morale.non_affilie', // Non affilié

    // Métiers physiques
    METIER_PHYSIQUE_LOUVETERIE: 'metier.physique.louveterie', // Lieutenants de louveterie
    METIER_PHYSIQUE_RISQUES_PRO: 'metier.physique.risques_pro', // Personnes exposées à des risques sérieux pour leur sécurité du fait de la nature ou du lieu d’exercice de son activité professionnelle
    METIER_PHYSIQUE_RISQUES_EXCEPTIONNELS: 'metier.physique.risques_exceptionnels', // Personnes exposées à des risques exceptionnels d’atteinte à la vie
    METIER_PHYSIQUE_COLLECTIONNEUR: 'metier.physique.collectionneur', // Collectionneurs

    // Métiers moraux
    METIER_MORALE_PROD_ET_THEATRES: 'metier.morale.prod_et_theatres', // Société de production et théâtres nationaux
    METIER_MORALE_PARCS_ZOOLOGIQUES: 'metier.morale.parcs_zoologiques', // Parcs zoologiques
    METIER_MORALE_FORAIN: 'metier.morale.forain', // Exploitants de tir forain
    METIER_MORALE_NUISIBLES: 'metier.morale.nuisibles', // Acteurs de la régulation des nuisibles et effaroucheurs
    METIER_MORALE_ESSAIS_INDUSTRIELS: 'metier.morale.essais_industriels', // Essais industriels
    METIER_MORALE_SECURITE_PRIVEE: 'metier.morale.securite_privee', // Entreprises de sécurité privée
    METIER_MORALE_CONVOYEUR: 'metier.morale.convoyeur', // Convoyeurs de fond
    METIER_MORALE_PROTECTION_NAVIRE: 'metier.morale.protection_navire', // Entreprises de protection privée des navires
    METIER_MORALE_FORMATION_SECURITE: 'metier.morale.formation_securite', // Prestataires de formations aux activités privées de sécurité
    METIER_MORALE_FORMATION_ARMURERIE: 'metier.morale.formation_armurerie', // Établissements de formation à l’armurerie
    METIER_MORALE_MUSEES: 'metier.morale.musees', // Musées
    METIER_MORALE_COLLECTIONNEUR: 'metier.morale.collectionneur', // Collectionneurs (personne morale)
    METIER_MORALE_NON_AFFILIE: 'metier.morale.non_affilie', // Non affilié
};

// Liste de tous les statuts
export const STATUTS_METIER_ASSO_LIST = Object.values(STATUTS_METIER_ASSO);

export const STATUTS_ASSOCIATIONS_TIR_SPORTIF = [
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFBT,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFS,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFTIR,
];

// Associations éligibles à la demande d'autorisation préfectorale (uniquement FFTIR)
export const STATUTS_ASSOCIATIONS_ELIGIBLES_AUTORISATION = [
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFTIR,
];

export const STATUS_METIERS_ELIGIBLES_AUTORISATION = [
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_LOUVETERIE,
    STATUTS_METIER_ASSO.METIER_MORALE_FORAIN,
    STATUTS_METIER_ASSO.METIER_MORALE_ESSAIS_INDUSTRIELS,
    STATUTS_METIER_ASSO.METIER_MORALE_SECURITE_PRIVEE,
    STATUTS_METIER_ASSO.METIER_MORALE_CONVOYEUR,
    STATUTS_METIER_ASSO.METIER_MORALE_PROTECTION_NAVIRE,
    STATUTS_METIER_ASSO.METIER_MORALE_FORMATION_SECURITE,
    STATUTS_METIER_ASSO.METIER_MORALE_PROD_ET_THEATRES,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_EXCEPTIONNELS,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_PRO,
    STATUTS_METIER_ASSO.METIER_MORALE_MUSEES,
    STATUTS_METIER_ASSO.METIER_MORALE_FORMATION_ARMURERIE,
    // SIAR-6341 : métiers auto-flaggés Catégorie C
    STATUTS_METIER_ASSO.METIER_MORALE_NUISIBLES,
    STATUTS_METIER_ASSO.METIER_MORALE_PARCS_ZOOLOGIQUES,
];

// SIAR-6341 : métiers dont la demande d'autorisation est automatiquement flaguée Catégorie C
export const METIERS_AUTO_CATEGORIE_C = [
    STATUTS_METIER_ASSO.METIER_MORALE_NUISIBLES,
    STATUTS_METIER_ASSO.METIER_MORALE_PARCS_ZOOLOGIQUES,
];

// SIAR-6341 : métier pour lequel l'utilisateur choisit entre Catégorie A/B et Catégorie C
export const METIER_CHOIX_CATEGORIE = STATUTS_METIER_ASSO.METIER_MORALE_ESSAIS_INDUSTRIELS;

// Statuts associés aux associations
export const STATUTS_ASSOCIATIONS = [
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFBT,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFS,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FNC,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFTIR,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFS,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFBT,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FNC,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_NON_AFFILIE,
];

export const STATUTS_ASSOCIATIONS_MORALE_AFFILIE = [
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFTIR,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFS,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFBT,
    STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FNC,
];

// Statuts associés aux métiers
export const STATUTS_METIERS = [
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_LOUVETERIE,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_PRO,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_EXCEPTIONNELS,
    STATUTS_METIER_ASSO.METIER_MORALE_PROD_ET_THEATRES,
    STATUTS_METIER_ASSO.METIER_MORALE_PARCS_ZOOLOGIQUES,
    STATUTS_METIER_ASSO.METIER_MORALE_FORAIN,
    STATUTS_METIER_ASSO.METIER_MORALE_NUISIBLES,
    STATUTS_METIER_ASSO.METIER_MORALE_ESSAIS_INDUSTRIELS,
    STATUTS_METIER_ASSO.METIER_MORALE_SECURITE_PRIVEE,
    STATUTS_METIER_ASSO.METIER_MORALE_CONVOYEUR,
    STATUTS_METIER_ASSO.METIER_MORALE_PROTECTION_NAVIRE,
    STATUTS_METIER_ASSO.METIER_MORALE_FORMATION_SECURITE,
    STATUTS_METIER_ASSO.METIER_MORALE_FORMATION_ARMURERIE,
    STATUTS_METIER_ASSO.METIER_MORALE_MUSEES,
    STATUTS_METIER_ASSO.METIER_MORALE_NON_AFFILIE,
];

// Statuts associés aux métiers physiques
export const STATUTS_METIERS_PHYSIQUES = [
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_LOUVETERIE,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_PRO,
    STATUTS_METIER_ASSO.METIER_PHYSIQUE_RISQUES_EXCEPTIONNELS,
];

// Fonction pour vérifier si un statut est un métier
export const isMetier = (statut) => {
    return STATUTS_METIERS.includes(statut);
};

// Fonction pour vérifier si un statut est une association
export const isAssociation = (statut) => {
    return STATUTS_ASSOCIATIONS.includes(statut);
};

// Fonction pour vérifier si un détenteur est éligible à la demande d'autorisation préfectorale
// Sont éligibles : les particuliers, les métiers (physiques et moraux) + associations FFTIR uniquement
export const isEligibleAutorisation = (statut) => {
    return (
        STATUS_METIERS_ELIGIBLES_AUTORISATION.includes(statut) ||
        STATUTS_ASSOCIATIONS_ELIGIBLES_AUTORISATION.includes(statut) ||
        (!isMetier(statut) && !isAssociation(statut))
    );
};

// Fonction pour vérifier si un statut est un métier physique
export const isMetierPhysique = (statut) => {
    return STATUTS_METIERS_PHYSIQUES.includes(statut);
};

// Fonction pour obtenir le type de statut
export const getTypeStatut = (statut) => {
    if (isMetierPhysique(statut)) return 'metier.physique';
    if (isAssociation(statut)) return 'association';
    return 'metier.morale';
};

export default STATUTS_METIER_ASSO;
